export default __webpack_public_path__ + "static/banner-three-shape5-66b24df964d65c14e1589891c0751562.png";